import { render } from "./LegalAlertView.vue?vue&type=template&id=564bf353&scoped=true"
import script from "./LegalAlertView.vue?vue&type=script&lang=js"
export * from "./LegalAlertView.vue?vue&type=script&lang=js"

import "./LegalAlertView.vue?vue&type=style&index=0&id=564bf353&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564bf353"]])

export default __exports__